module.exports = __webpack_public_path__ + "static/img/orderIndex.336341f0.png";